import breakPoints from 'helpers/Styles';

const ThreeColumnsImages = ({ block, primaryFontColor }) => {
  if (!block) return '';
  const { primary } = block;
  const title_one = primary?.title_one ? primary.title_one : null;
  const title_one_colour = primary?.title_one_colour
    ? primary.title_one_colour
    : primaryFontColor;
  const title_two = primary?.title_two ? primary.title_two : null;
  const title_two_colour = primary?.title_two_colour
    ? primary.title_two_colour
    : primaryFontColor;
  const title_three = primary.title_three ? primary.title_three : null;
  const title_three_colour = primary?.title_three_colour
    ? primary.title_three_colour
    : primaryFontColor;
  const image_one = primary.image_one ? primary.image_one.url : null;
  const image_two = primary.image_two ? primary.image_two.url : null;
  const image_three = primary.image_three ? primary.image_three.url : null;

  return (
    <>
      <div className='three_columns_images wrapper'>
        <div className='column_block'>
          <img draggable='false' src={image_one} alt='image_one' />
          <div className='title title1'>{title_one}</div>
        </div>
        <div className='column_block'>
          <img draggable='false' src={image_two} alt='image_two' />
          <div className='title title2'>{title_two}</div>
        </div>
        <div className='column_block third_block'>
          <img draggable='false' src={image_three} alt='image_three' />
          <div className='title title3'>{title_three}</div>
        </div>
      </div>
      <style jsx>
        {`
          .three_columns_images {
            display: flex;
            width: 100%;
            padding: 50px 0;
            background-color: inherit;
          }
          .column_block {
            width: 35%;
            height: 720px;
            position: relative;
          }
          .column_block img {
            width: 100%;
            height: 720px;
          }
          .title {
            position: absolute;
            font-family: 'big_noodle_titling';
            font-size: 31px;
            letter-spacing: 0;
            line-height: 40px;
            bottom: 30px;
            left: 30px;
          }
          .title1 {
            color: ${title_one_colour};
          }
          .title2 {
            color: ${title_two_colour};
          }
          .title3 {
            color: ${title_three_colour};
          }
          @media (max-width: ${breakPoints.small}) {
            .three_columns_images {
              flex-wrap: wrap;
            }
            .column_block {
              width: 50%;
              max-height: 280px;
            }
            .column_block img {
              max-height: 280px;
            }
            .third_block {
              width: 100%;
              min-height: 280px;
            }
            .third_block img {
              min-height: 290px;
            }
          }
        `}
      </style>
    </>
  );
};

export default ThreeColumnsImages;
